import { BaseMaskAdapter } from "./base-adapter";

export class WeightPresetAdapter extends BaseMaskAdapter {
  constructor() {
    super("");
  }
  private readonly formatter = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });

  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.formatter.format(Number(value));
  }

  parseFromInput(inputValue: string): { value: number; formatted: string } {
    if (inputValue === "" || this.cleanValue(inputValue) === "") {
      return { value: 0, formatted: "" };
    }

    // Handle weight like currency-input does (4 decimal places)
    const digits = this.cleanNumericInput(inputValue);
    const numericValue = Number(digits) / 10000;
    const formattedValue = this.formatter.format(numericValue);

    return {
      value: numericValue,
      formatted: formattedValue,
    };
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.formatter.format(Number(value));
  }

  isKeyAllowed(key: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    return /^\d$/.test(key);
  }
}
